import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

const SimpleTabs = ({ tabs, content, initialTab }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const initialTabIndex = initialTab
    ? tabs.findIndex((tab) => tab.key === initialTab)
    : -1;

  React.useEffect(() => {
    if (initialTabIndex >= 0) {
      setValue(initialTabIndex);
    }
  }, [initialTabIndex]);

  React.useEffect(() => {
    if (value >= tabs.length) {
      setValue(0);
    }
  }, [tabs.length, value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default" className="Appbar-user">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Tabs"
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs &&
            tabs.map((tab, index) => {
              return (
                <Tab
                  key={tab.key || tab.title}
                  label={tab.title}
                  {...a11yProps(index)}
                />
              );
            })}
        </Tabs>
      </AppBar>
      {content &&
        content.map((item, index) => {
          return (
            <TabPanel
              key={tabs[index]?.key || tabs[index]?.title || index}
              value={value}
              index={index}
              className="tab-panel"
            >
              {item}
            </TabPanel>
          );
        })}
    </div>
  );
};

SimpleTabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  content: PropTypes.array.isRequired,
  initialTab: PropTypes.string,
};

export default SimpleTabs;
